module.exports = __webpack_public_path__ + "static/media/uikit.858adaad.svg";